<app-accordion>
<app-accordion-item icon="archive" id="inventorySearch" label="Estoque">
  <div class="flex flex-col gap-3 md:flex-row md:items-end">
    <div class="flex-1">
      <label class="block text-sm font-medium mb-1">Contas</label>
      <ng-select
        [items]="franchises"
        bindLabel="label"
        bindValue="name"
        [hideSelected]="true"
        [closeOnSelect]="false"
        [clearable]="true"
        [searchable]="true"
        [multiple]="true"
        [(ngModel)]="selectedAccounts"
        [placeholder]="'Selecione as contas'"
        [loading]="loadingAccounts"
        [searchFn]="customSearchFn"
        class="w-full control-height"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          {{ item.name?.toUpperCase() }}
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="flex flex-col">
            <span class="font-medium">{{ item.name }}</span>
            <span class="text-xs text-neutral-500">{{ item.description }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="md:ml-2">
      <app-button color="primary" (buttonClick)="search()" icon="search">Buscar</app-button>
    </div>
  </div>

  @if (loading) {
  <div class="my-2"><app-loading /></div>
  } @if (!!error) {
  <app-alert [type]="'danger'">{{ error }}</app-alert>
  } @if (hasSearched && !loading) {
  <app-accordion [multiple]="false">
    @for (r of sortedResults; track r.name) {
    <app-accordion-item
      [id]="`AccordionItemSku${skuId}Warehouse${r.id}`"
      [label]="`${r.name} (${r.id}) - Disponível: ${getAvailableTotal(r)}`"
      [headerClass]="getAvailableTotal(r) > 0 ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300'"
    >
      @for (item of r.items; track item.warehouseId) {
      <div
        class="rounded border border-neutral-200 dark:border-neutral-700 p-3 bg-white dark:bg-neutral-900"
      >
        <div class="flex flex-wrap justify-between gap-2">
          <div>
            <div class="text-sm text-neutral-500">Warehouse ({{ item.warehouseId }})</div>
            <div class="font-medium">{{ item.warehouseName }})</div>
          </div>
          <div class="text-right">
            <div class="text-sm text-neutral-500">Disponível</div>
            <div class="font-semibold">
              {{ item.hasUnlimitedQuantity ? '∞' : item.totalQuantity - item.reservedQuantity }}
            </div>
          </div>
        </div>
        <div class="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
          <div>
            <div>Total</div>
            <div>{{ item.totalQuantity }}</div>
          </div>
          <div>
            <div>Reservado</div>
            <div>{{ item.reservedQuantity }}</div>
          </div>
          <div>
            <div>Ilimitado</div>
            <div>{{ item.hasUnlimitedQuantity ? 'Sim' : 'Não' }}</div>
          </div>
        </div>
        <div
          class="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs text-neutral-600 dark:text-neutral-300"
        >
          <div>
            <div>Tempo Reposição</div>
            <div>{{ item.timeToRefill || '-' }}</div>
          </div>
          <div>
            <div>Data Abastecimento (UTC)</div>
            <div>{{ item.dateOfSupplyUtc || '-' }}</div>
          </div>
          <div>
            <div>Lead Time</div>
            <div>{{ item.leadTime || '-' }}</div>
          </div>
        </div>
      </div>
      }
    </app-accordion-item>
    }
  </app-accordion>
  }
</app-accordion-item>
</app-accordion>
